import React, { useState, useEffect } from 'react';
import { StatusProcesso } from '../../../model/processo/Processo';
import { ProcessoUtils } from '../../../model/processo/Processo';
import { FaArrowRight, FaTimes } from 'react-icons/fa';
import { BsArrowLeftRight, BsCheckCircleFill } from 'react-icons/bs';

interface StatusModalProps {
  selectedStatus: StatusProcesso;
  onClose: () => void;
}

const StatusModal: React.FC<StatusModalProps> = ({ selectedStatus, onClose }) => {
  const [currentStatus, setCurrentStatus] = useState<StatusProcesso>(selectedStatus);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const mainFlowStatuses = [
    StatusProcesso.CRIADO,
    StatusProcesso.PLANEJADO,
    StatusProcesso.DEFINIDO,
    StatusProcesso.FACIAL,
    StatusProcesso.VIRTUAL,
    StatusProcesso.RECURSAL
  ];

  const getStatusIcon = (status: StatusProcesso) => {
    switch (status) {
      case StatusProcesso.FINALIZADO: return <BsCheckCircleFill className="me-1" />;
      case StatusProcesso.CANCELADO: return <FaTimes className="me-1" />;
      default: return null;
    }
  };

  return (
    <>
      <div 
        className="modal-backdrop"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(8px)',
          zIndex: 1040,
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.2s ease-in-out'
        }}
        onClick={onClose}
      />
      <div className="modal fade show" style={{ 
        display: 'block', 
        zIndex: 1050,
        opacity: isVisible ? 1 : 0,
        transform: `scale(${isVisible ? 1 : 0.9}) translateY(${isVisible ? '0' : '20px'})`,
        transition: 'all 0.2s ease-in-out'
      }} tabIndex={-1}>
        <div className="modal-dialog" style={{ maxWidth: '1000px' }}>
          <div className="modal-content">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title">Fluxo de Status dos Processos de Heteroidentificação</h5>
              <button 
                type="button" 
                className="btn-close btn-close-white" 
                onClick={onClose}
                aria-label="Fechar"
              ></button>
            </div>
            <div className="modal-body">
              {/* Fluxo Principal */}
              <div className="mb-4">
                <div className="d-flex align-items-center justify-content-center" style={{ flexWrap: 'nowrap' }}>
                  {[...mainFlowStatuses, StatusProcesso.FINALIZADO].map((status, index) => (
                    <React.Fragment key={status}>
                      <button
                        type="button"
                        className={`btn btn-status ${currentStatus === status ? 'active' : ''}`}
                        style={{
                          backgroundColor: ProcessoUtils.getStatusColor(status),
                          border: currentStatus === status ? '2px solid #000' : '1px solid #ccc',
                          boxShadow: currentStatus === status ? '0 0 15px rgba(0,0,0,0.5)' : 'none',
                          transform: currentStatus === status ? 'scale(1.1)' : 'scale(1)',
                          minWidth: '110px',
                          margin: '0 3px',
                          fontSize: '0.8rem',
                          fontWeight: currentStatus === status ? 'bold' : 'normal',
                          transition: 'all 0.2s ease'
                        }}
                        onClick={() => setCurrentStatus(status)}
                      >
                        {getStatusIcon(status)}
                        {status}
                      </button>
                      {index < mainFlowStatuses.length && (
                        <div className="arrow-connector mx-1">
                          {status === StatusProcesso.VIRTUAL ? (
                            <BsArrowLeftRight />
                          ) : (
                            <FaArrowRight />
                          )}
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>

              {/* Caso de Exceção */}
              <div className="mb-4">
                <div className="d-flex justify-content-center">
                  <button
                    type="button"
                    className={`btn btn-status btn-sm ${currentStatus === StatusProcesso.CANCELADO ? 'active' : ''}`}
                    style={{
                      backgroundColor: ProcessoUtils.getStatusColor(StatusProcesso.CANCELADO),
                      border: currentStatus === StatusProcesso.CANCELADO ? '4px solid #000' : '1px solid #666',
                      boxShadow: currentStatus === StatusProcesso.CANCELADO ? '0 0 15px rgba(0,0,0,0.5)' : 'none',
                      transform: currentStatus === StatusProcesso.CANCELADO ? 'scale(1.1)' : 'scale(1)',
                      minWidth: '100px',
                      fontSize: '0.8rem',
                      fontWeight: currentStatus === StatusProcesso.CANCELADO ? 'bold' : 'normal',
                      transition: 'all 0.2s ease'
                    }}
                    onClick={() => setCurrentStatus(StatusProcesso.CANCELADO)}
                  >
                    {getStatusIcon(StatusProcesso.CANCELADO)}
                    {StatusProcesso.CANCELADO}
                  </button>
                </div>
              </div>

              {/* Descrição do Status */}
              <div className="status-description p-4 rounded mt-4" style={{ 
                backgroundColor: '#f8f9fa',
                borderLeft: `4px solid ${ProcessoUtils.getStatusColor(currentStatus)}`
              }}>
                <h5 className="text-center mb-3">
                  <strong>Processo {currentStatus}</strong>
                </h5>
                <p className="text-center">{ProcessoUtils.getStatusExplanation(currentStatus)}</p>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-primary" 
                onClick={onClose}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusModal;